<template>
  <div>
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: "customermain"
}
</script>

<style scoped></style>